import { DISPPLAY_MOMENT_YMD_HM } from '@/configs/constants';
import { useStore } from '@/hooks/useStore';
import { formatDateTime } from '@/utils/datetime';
import { flowResult } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default observer(function NoteDetail({ id }: { id: number }) {
    // hook
    const { t } = useTranslation();

    // store
    const { approveStore: { getResionByBikeId } } = useStore();

    // state
    const [noteList, setNoteList] = useState([]);

    useEffect(() => {
        fetchNote();
    }, []);

    const fetchNote = async () => {
        const res = await flowResult(getResionByBikeId(id));
        if (res) {
            setNoteList(res);
        }
    };

    return (
        <div className='flex flex-col md:gap-5 gap-3 overflow-y-auto max-h-[70vh] pr-2'>
            {noteList?.length > 0 ?
                (
                    noteList.map((note: NoteItemProps, index) => (
                        <NoteItem key={index} {...note} index={noteList?.length - index} />
                    ))
                ) :
                (
                    <p>{t('sentences.no_data')}</p>
                )}

        </div>
    );
});

interface NoteItemProps {
    id: number,
    bikeId: number,
    approveStatus: number | string,
    approveNote: string,
    createdAt: string,
    creator: {
        fullname: string,
        email: string
    },
    index: number
}
const NoteItem = (note: NoteItemProps) => {
    const { t } = useTranslation();

    return (
        <div className='flex flex-col gap-2.5'>
            <h3 className='font-medium'>{`${t('words_title.comment')} ${note.index}`}</h3>
            <div className='bg-border-4 rounded-base'>
                <p className='px-3 py-4 break-all'>{note.approveNote}</p>
            </div>
            <div className='w-full flex justify-end'>
                <p className='text-placeholder whitespace-pre-wrap'>
                    {t('words_title.note_time')}
                    :
                    <span>{` ${formatDateTime(note.createdAt, DISPPLAY_MOMENT_YMD_HM)} ${note?.creator?.email}`}</span>
                </p>
            </div>
        </div>
    );
};
